// extracted by mini-css-extract-plugin
export default {"layout":"_09a6114c02 _257d5a6694 _8bae88151e","h_slide":"_10fabf1278","category":"_7ba8664d45 eb3855b138 b97d963be9"};